import React, {memo, ReactNode} from 'react';

import './index.scss';
import {useOrientation} from '../../hooks/orientation';

type Props = {
    className?: string;
    children?: ReactNode;
};

export const Container = memo(function Container({children, className}: Props) {
    const orientation = useOrientation();

    return (
        <div
            className={'container ' + orientation + (Boolean(className) ? ` ${className}` : '')}>
            {children}
        </div>
    );
});
